export default __webpack_public_path__ + "static/media/new-pc.8d31249a.svg";